import { useState } from "react";

export function useBulkHoverHighlight<TId>(selectedIds: Set<TId>): {
  onHover: (id: TId) => void;
  onHoverLeave: () => void;
  isHighlighted: (id: TId) => boolean;
};

export function useBulkHoverHighlight<TId, TCol>(
  selectedIds: Set<TId>,
): {
  onHover: (id: TId, col: TCol) => void;
  onHoverLeave: () => void;
  isHighlighted: (id: TId, col: TCol) => boolean;
};

export function useBulkHoverHighlight<TId, TCol>(selectedIds: Set<TId>) {
  const [hovered, setHovered] = useState<{
    id: TId;
    col: TCol | undefined;
  } | null>(null);

  return {
    onHover: (id: TId, col?: TCol) => setHovered({ id, col }),
    onHoverLeave: () => setHovered(null),
    isHighlighted: (id: TId, col?: TCol) =>
      hovered !== null &&
      selectedIds.size > 1 &&
      selectedIds.has(hovered.id) &&
      selectedIds.has(id) &&
      hovered.col === col,
  };
}
